import BaseButton from "./BaseButton";
import { ButtonBounds } from "../../types/Interface";
import { ButtonStatus, Sounds } from "../../types/Enum";


export default class AutoPlayButton extends BaseButton {
  isVertical = false;
  Bounds: ButtonBounds;
  count: number = 0;
  constructor(Bounds: ButtonBounds, isVertical) {
    super("auto_play", Sounds.click3);
    Object.assign(this, Bounds);
    this.Bounds = Bounds;
    this.isVertical = isVertical;

    this.EventBus.on(this.EnumEventBus.sendCountAmount, (count: string) => this.setCount(Number(count)));
    this.EventBus.on(this.EnumEventBus.autoGameIsCompleted, () => this.startAutoPlay());
    this.EventBus.on(this.EnumEventBus.setAPlayButStatus, (value: ButtonStatus) => this.setButtonStatus(value));
  }
  setCount(count: number) {
    this.count = count;
    this.EventBus.emit(this.EnumEventBus.setStopBarCount, count);
    this.setVisible(false);
    this.startAutoPlay();
  }
  startAutoPlay() {
    if (this.count > 0) {
      this.EventBus.emit(this.EnumEventBus.setStopBarCount, this.count);
      this.count--;
      setTimeout(() => {
        this.EventBus.emit(this.EnumEventBus.spin, true);
      }, 500);
    } else {
      this.count = 0;
      this.setButtonStatus(ButtonStatus.show);
      this.exchangeTexture(this.regular);
      this.EventBus.emit(this.EnumEventBus.setPlayButStatus, ButtonStatus.show);
      this.EventBus.emit(this.EnumEventBus.setAllButtonIntractvy, true);
      this.EventBus.emit(this.EnumEventBus.setStopBarCount, this.count);
    }
  }

  handlePress() {
    this.EventBus.emit(this.EnumEventBus.setAllButtonIntractvy, false);
    this.EventBus.emit(this.EnumEventBus.setCountConVis, true);
  }
  setButtonStatus(value: ButtonStatus) {
    if (value == ButtonStatus.semiOpacity) {
      this.setAvaible(false);
    }
    else if (value == ButtonStatus.show) {
      this.setAvaible(true);
      this.setVisible(true);
    }
    else if (value == ButtonStatus.hide) {
      this.setAvaible(false);
      this.setVisible(false);
    }
  }
  setAvaible(value: boolean) {
    this.alpha = value ? 1 : .5;
    this.setInteractivity(value)
  }
  setInteractivity(v: boolean) {
    this.interactive = v;
  }
  setVisible(value: boolean) {
    this.visible = value;
    this.exchangeTexture(this.regular);
  }
}